import { call, put, takeLatest } from 'redux-saga/effects';
import firebase, { reduxSagaFirebase } from '../../../firebase';
import { fetchInventoryPumpsSuccess } from './actions';
import * as actionType from './types';
import { InventoryType } from '../types';

// iPads
function* fetchInventoryPumps() {
  try {
    yield call(
      reduxSagaFirebase.firestore.syncCollection,
      firebase.firestore().collection(`inventory`).where('type', '==', InventoryType.PUMP),
      { successActionCreator: fetchInventoryPumpsSuccess }
    );
  } catch (e: any) {
    yield put({ type: actionType.PUMP_INVENTORY_FETCH_FAILED, message: e.message });
  }
}

export function* fetchInventoryPumpsSaga() {
  // @ts-ignore
  yield takeLatest(actionType.PUMP_INVENTORY_FETCH_REQUESTED, fetchInventoryPumps);
}
